declare const API_URL: string | undefined;

const resolveApiBaseUrl = (): string => {
    if (typeof API_URL !== 'undefined' && API_URL) {
        return API_URL;
    }
    if (process.env.API_URL) {
        return process.env.API_URL;
    }
    return 'http://localhost:9000';
};

const apiBaseUrl = resolveApiBaseUrl();

const resolveEnv = (): 'production' | 'stage' | 'local' => {
    if (apiBaseUrl.indexOf('api.myhappyforce') > -1) {
        return 'production';
    }
    if (apiBaseUrl.indexOf('api-staging.myhappyforce') > -1) {
        return 'stage';
    }
    return 'local';
};

export const appSettings = {
    APIUrl: `${apiBaseUrl}/api/v1`,
    angularMomentConfig: {
        timezone: 'Europe/Madrid'
    },
    defaultDateFormat: 'MMM DD, YYYY',
    defaultMonthDateFormat: 'MMM YYYY',
    defaultQuarterDateFormat: '[Q]Q-YYYY',
    defaultYearDateFormat: 'YYYY',
    defaultTimeFormat: 'HH:mm',
    env: resolveEnv(),
    apiDateFormat: 'DDMMYYYY',
    announcementSectionsConfig: {
        celebrationSectionId: '63ad5dbdaee16935acb036c5',
        commentReplySectionId: '6405dd0386501193da23207b'
    }
};

export type AppSettings = typeof appSettings;
